import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as S from "../../style/StyleComponentSection";
import * as U from "../../style/StyleComponentUtility";
import { useLocation } from "react-router-dom";
import { RootState } from "../../redux/Store";
import { get_qna_select_one } from "../../Axios";
import { get_day_timestamp } from "../../Validation";
import noImage from "../../assets/images/no_image_angle.png";
import leftArrow from "../../assets/icons/stroke_left.svg";
import rightArrow from "../../assets/icons/stroke_right.svg";
import closeIcon from "../../assets/icons/close_30.svg";

interface QnaObject {
  ablack_ask_ID: number;
  ablack_ask_customer_ID: number;
  ablack_ask_progress: number;
  ablack_ask_progress_name: string;
  ablack_ask_division: number;
  ablack_ask_division_name: string;
  ablack_ask_question: string;
  ablack_ask_answer: string;
  ablack_ask_registe: any;
  ablack_ask_modified: any;
  ablack_ask_status: number;
};

const QNASelectOne: React.FC = () => {
  const { state } = useLocation();
  const customerData = useSelector((state: RootState) => state.customerData);
  const [qna, setQna] = useState<QnaObject>();
  const [imageList, setImageList] = useState<any[]>([]);
  const [bigImageSRC, setBigImageSRC] = useState<string>("");
  const [bigImageIndex, setBigImageIndex] = useState<number>(0);

  const [toggleQuestion, setToggleQuestion] = useState<boolean>(false);
  const [toggleAnswer, setToggleAnswer] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);

  useEffect(() => {
    get_qna_select_one(
      customerData.customer_ID,
      state.ablack_ask_ID
    ).then(result => {
      setQna(result.rows);
      let list: (string | null)[] = result.images;
      let image_list = list.filter(el => el !== null);
      setImageList(image_list);
      setBigImageSRC(result.images[0]);
    });
  }, [customerData.customer_ID, state]);

  return (
    <S.SectionContainer>
      <S.SectionWidth $width={900}>
        <U.BreakLine $height={60} />

        <S.ReservationSelectOneContainer>
          <div>
            <div className="content-title">
              1:1 문의 상세
            </div>
            <U.BreakLine $height={30} />
            <S.SectionBorderContainer>
              <div className="content-line">
                <div className="label-box">상태</div>
                <div className="content-box">{qna?.ablack_ask_progress_name}</div>
              </div>
              <hr />
              <div className="content-line">
                <div className="label-box">구분</div>
                <div className="content-box">{qna?.ablack_ask_division_name}</div>
              </div>
              <hr />
              <div className="content-line">
                <div className="label-box">문의 날짜</div>
                <div className="content-box">{get_day_timestamp(qna?.ablack_ask_registe).year_month_day}</div>
              </div>
              <hr />
              <div className="content-line">
                <div className="label-box">문의 내용</div>
                <div
                  className={`
                    content-box whitespace-pre-line
                    ${toggleQuestion ? "overflow-y-scroll h-20" : ""}
                  `}
                >
                    <div className="flex justify-end items-center">
                      <button
                        onClick={() => {
                          setToggleQuestion(!toggleQuestion);
                        }}
                        className="text-middleGray01 text-sm"
                      >
                        {toggleQuestion ? "펼치기" : "접기"}
                      </button>
                    </div>
                    {qna?.ablack_ask_question}
                </div>
              </div>
              {qna?.ablack_ask_answer &&
                <>
                  <hr />
                  <div className="content-line">
                  <div className="label-box">답변 내용</div>
                  <div
                    className={`
                      content-box whitespace-pre-line
                      ${toggleAnswer ? "overflow-y-scroll h-20" : ""}
                    `}
                  >
                    <div className="flex justify-end items-center">
                      <button
                        onClick={() => {
                          setToggleAnswer(!toggleAnswer);
                        }}
                        className="text-middleGray01 text-sm"
                      >
                        {toggleAnswer ? "펼치기" : "접기"}
                      </button>
                    </div>
                    {qna?.ablack_ask_answer}
                  </div>
                </div>
                </>
              }
            </S.SectionBorderContainer>
          </div>
        </S.ReservationSelectOneContainer>

        <div className="flex justify-center">

          {imageList.length !== 0 &&
            <S.SelectOnePortfolioImageBox className="mt-[30px]">
              <div
                className="big-image-box"
                style={{
                  height: 0,
                  overflow: "hidden"
                }}
                onClick={() => {
                  setModal(true);
                }}
              >
                <img src={bigImageSRC} alt="" />
              </div>
              <div className="image-list-box">
                {imageList[0] ?
                  <div className="individaul-box" onClick={() => {
                    setBigImageSRC(imageList[0]);
                    setBigImageIndex(0)
                  }}>
                    <img width={130} height={87} src={imageList[0]} alt="" />
                  </div>
                  :
                  <div>
                    <img width={130} height={87} src={noImage} alt="" />
                  </div>
                }
                {imageList[1] ?
                  <div className="individaul-box" onClick={() => {
                    setBigImageSRC(imageList[1]);
                    setBigImageIndex(1)
                  }}>
                    <img width={130} height={87} src={imageList[1]} alt="" />
                  </div>
                  :
                  <div>
                    <img width={130} height={87} src={noImage} alt="" />
                  </div>
                }
                {imageList[2] ?
                  <div className="individaul-box" onClick={() => {
                    setBigImageSRC(imageList[2]);
                    setBigImageIndex(2)
                  }}>
                    <img width={130} height={87} src={imageList[2]} alt="" />
                  </div>
                  :
                  <div>
                    <img width={130} height={87} src={noImage} alt="" />
                  </div>
                }
                {imageList[3] ?
                  <div className="individaul-box" onClick={() => {
                    setBigImageSRC(imageList[3]);
                    setBigImageIndex(3)
                  }}>
                    <img width={130} height={87} src={imageList[3]} alt="" />
                  </div>
                  :
                  <div>
                    <img width={130} height={87} src={noImage} alt="" />
                  </div>
                }
              </div>
            </S.SelectOnePortfolioImageBox>
          }
        </div>

        {modal &&
          <S.SelectOnePortfolioModal onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            if (!(e.target instanceof HTMLImageElement)) {
              setModal(false);
            }
          }}>

            <div className="flex-box">
              <div className="close-box right-[12%] 2xl:right-[25%]">
                <img src={closeIcon} alt="" onClick={() => setModal(false)} />
              </div>

              <div className="arrow-box left-[12%] 2xl:left-[25%]">
                {imageList.length > 1 &&
                  <button onClick={() => {
                    if (bigImageIndex !== 0) {
                      setBigImageIndex(bigImageIndex - 1);
                      setBigImageSRC(imageList[bigImageIndex - 1]);
                    } else if (bigImageIndex === 0) {
                      setBigImageIndex(imageList.length - 1);
                      setBigImageSRC(imageList[imageList.length - 1]);
                    }
                  }}>
                    <img src={leftArrow} alt="" />
                  </button>
                }
              </div>

              <div className="modal-image-box">
                <img src={bigImageSRC} alt="" />
              </div>

              <div className="arrow-box right-[12%] 2xl:right-[25%]">
                {imageList.length > 1 &&
                  <button onClick={() => {
                    if (bigImageIndex + 1 < imageList.length) {
                      setBigImageIndex(bigImageIndex + 1);
                      setBigImageSRC(imageList[bigImageIndex + 1]);
                    } else {
                      setBigImageIndex(0);
                      setBigImageSRC(imageList[0]);
                    }
                  }}>
                    <img src={rightArrow} alt="" />
                  </button>
                }
              </div>
            </div>

            <div className="index-box">
              {bigImageIndex + 1} / {imageList.length}
            </div>

          </S.SelectOnePortfolioModal>
        }

        <U.BreakLine $height={60} />
      </S.SectionWidth>
    </S.SectionContainer>
  )
};

export default QNASelectOne;